document.querySelectorAll('.card-product-form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const submitButton = form.querySelector('button');
    const variantId = form.querySelector('.card-variant-select').value;

    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = '/checkout';
      });
  });
});

// Get all grid containers
document.querySelectorAll('section').forEach((wrp) => {
  if (!wrp.querySelector('.scroll-grid-container')) {
    return;
  }
  wrp.querySelectorAll('.scroll-grid-container').forEach((container) => {
    const gridId = container.querySelector('.scroll-grid').id;
    const grid = container.querySelector('.scroll-grid');
    const leftButton = container.querySelector(`.scroll-left[data-grid="${gridId}"]`);
    const rightButton = container.querySelector(`.scroll-right[data-grid="${gridId}"]`);

    const scrollAmount = 296; // 280px + 16px gap

    // Add click handlers for this specific grid
    if (leftButton) {
      leftButton.addEventListener('click', () => {
        grid.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth',
        });
      });
    }

    if (rightButton) {
      rightButton.addEventListener('click', () => {
        grid.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
      });
    }
  });
});

// Get all tab links
const tabLinks = document.querySelectorAll('.featured-collection-wrp');
// const wrpDivs = document.querySelectorAll('.featured-collection-wrp > div');

// Add click event listener to each tab link
tabLinks.forEach((tab) => {
  const links = tab.querySelectorAll('.line-menu a');
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const clickedTab = link.textContent;

      // Update active state of all links
      links.forEach((l) => {
        const targetId = l.dataset.url;
        if (l.textContent === clickedTab) {
          l.classList.add('active');
          // console.log(l.dataset);
          document.getElementById(targetId).classList.remove('dn');
        } else {
          l.classList.remove('active');
          // console.log(l.dataset);
          document.getElementById(targetId).classList.add('dn');
        }
      });

      // Show/hide wrp divs
      // wrpDivs.forEach((div) => {
      //   const menuText = div.querySelector('.line-menu a').textContent;
      //   if (menuText === clickedTab) {
      //     div.classList.remove('dn');
      //   } else {
      //     div.classList.add('dn');
      //   }
      // });
    });
  });
});
